import { useEffect, useState } from 'react';
import queryString from 'query-string';
import { Input, Empty, Radio, Space } from 'antd';
import { MUIPagination } from '../../pagination';
import { prices } from '../../inputs/price-range';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { useHistory } from 'react-router';
import { allLocations } from '../../../../services/admin';
import { allCategories } from '../../../../services/product';
import { searchResults } from '../../../../services/product';
import Footer from '../../../layout/footer';
const { Search } = Input;

const API = (process.env.REACT_APP_API ).replace(/\/api$/, '');

const SearchResult = () => {
  const countPerPage = 10;
  const [location, setLocation] = useState('');
  const [category, setCategory] = useState('');
  const [name, setName] = useState('');
  const [price, setPrice] = useState([]);
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [condition, setCondition] = useState('');
  const [locationName, setLocationName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [searchResult, setSearchResult] = useState([]);
  const [current, setCurrent] = useState();
  const [pagination, setPagination] = useState();
  const history = useHistory();
  const minId = document.querySelector('.min');
  const maxId = document.querySelector('.max');

  const loadSearchResults = async (page) => {
    const { location, category, name } = queryString.parse(
      window.location.search
    );
    setCategory(category);
    setLocation(location);
    setName(name);
    const res = await searchResults({
      location,
      category,
      name,
      price,
      condition,
    });
    setCurrent(page);
    const to = page * countPerPage;
    const from = to - countPerPage;
    setPagination(res.data.slice(from, to));
    setSearchResult(res.data);
  };

  const loadCategories = async () => {
    const { category } = queryString.parse(window.location.search);
    const res = await allCategories();
    res.data.filter((cat) => {
      if (cat._id === category) {
        setCategoryName(cat.name);
      }
    });
  };
  const loadLocations = async () => {
    const { location } = queryString.parse(window.location.search);
    const res = await allLocations();
    res.data.filter((loc) => {
      if (loc._id === location) {
        setLocationName(loc.name);
      }
    });
  };

  const handleCondition = (e) => {
    setCondition(e.target.value);
    history.push(
      `search-result?&location=${location}&category=${category}&name=${name}&price=${price}&condition=${e.target.value}`
    );
  };

  const handlePriceRange = (e) => {
    setPrice(e.target.value);
    history.push(
      `search-result?&location=${location}&category=${category}&name=${name}&price=${e.target.value}&condition=${condition}`
    );
    setMin('');
    setMax('');
  };

  const handleSearch = (e) => {
    setName(e.target.value);
  };

  const handleSubmit = (name) => {
    history.push(
      `search-result?&location=${location}&category=${category}&name=${name}&price=${price}&condition=${condition}`
    );
  };

  const handleMin = (e) => {
    setMin(e.target.value);
    minId.style.border = '1px solid #ced4da';
  };
  const handleMax = (e) => {
    setMax(e.target.value);
    maxId.style.border = '1px solid #ced4da';
  };
  const handleSubmitPrice = () => {
    if (!min && !max) {
      minId.style.border = '1px solid red';
      maxId.style.border = '1px solid red';
      return;
    }
    if (!min) {
      minId.style.border = '1px solid red';
      maxId.style.border = '1px solid #ced4da';
      return;
    }
    if (!max) {
      maxId.style.border = '1px solid red';
      minId.style.border = '1px solid #ced4da';
      return;
    }
    const newArray = [];
    newArray[0] = parseInt(min);
    newArray[1] = parseInt(max);

    setPrice(newArray);

    history.push(
      `search-result?&location=${location}&category=${category}&name=${name}&price=${newArray}&condition=${condition}`
    );
  };

  //format currency
  Number.prototype.format = function (n, x) {
    var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$&,');
  };

  useEffect(() => {
    loadSearchResults(1);
    loadCategories();
    loadLocations();
  }, [window.location.search]);

  return (
    <>
      <div className='search-header mb-3 container-fluid'>
        <div className='row search'>
          <p className='header-text text-center me-2 d-flex justify-content-center'>
            Buscando por&nbsp;
            {categoryName ? categoryName : <span>Produtos</span>}&nbsp;em&nbsp;
            {locationName ? locationName : <span>Brasil</span>}
          </p>
          <div className='col-md-8 mx-auto d-flex justify-content-center'>
            <Search
              value={name}
              className='shadow-none'
              placeholder='Digite sua busca aqui'
              allowClear
              style={{ width: '80%' }}
              enterButton='Buscar'
              size='large'
              onChange={handleSearch}
              onSearch={handleSubmit}
            />
          </div>
        </div>
      </div>

      <div className='row container-fluid mx-auto mt-3 mb-5 profile-container'>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/' className='text-decoration-none'>
              Início
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {categoryName ? categoryName : <span>Produtos</span>}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className='col-md-3 mb-2'>
          <div className='card rounded-0 profile-card card-shadow'>
            <div className='card-header p-3'>
              <strong>
                <p className='text-dark1'>Condição</p>
              </strong>
              <Radio.Group onChange={handleCondition} value={condition}>
                <Space direction='vertical'>
                  <Radio value={''}>Qualquer</Radio>
                  <Radio value={'New'}>Novo</Radio>
                  <Radio value={'Used'}>Usado</Radio>
                </Space>
              </Radio.Group>
              <hr />
              <strong>
                <p className='text-dark1'>Faixa de preço</p>
              </strong>
              <div className='mb-2'>
                <Radio.Group onChange={handlePriceRange} value={price}>
                  <Space direction='vertical'>
                    {prices.map((p, i) => {
                      return (
                        <Radio key={i} value={p.array}>
                          {p.name}
                        </Radio>
                      );
                    })}
                  </Space>
                </Radio.Group>
              </div>
              <span>Preço personalizado:</span>
              <div className='form-group d-flex justify-content-center align-items-center'>
                <div className='input-group input-group-sm me-2'>
                  <span className='input-group-text' id='inputGroup-sizing-sm'>
                    R$
                  </span>
                  <input
                    type='number'
                    className='form-control rounded-0 shadow-none min'
                    id='min'
                    value={min}
                    onChange={handleMin}
                  />
                </div>
                <div>a</div>
                <div className='input-group input-group-sm ms-2'>
                  <span className='input-group-text' id='inputGroup-sizing-sm'>
                    R$
                  </span>
                  <input
                    type='number'
                    className='form-control rounded-0 shadow-none max'
                    id='max'
                    value={max}
                    onChange={handleMax}
                  />
                </div>
                <div>
                  <button
                    onClick={handleSubmitPrice}
                    className='btn btn-primary btn-sm rounded-0 shadow-none ms-1'
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-9'>
          <div className='card rounded-0 profile-card card-shadow'>
            <div className='card-header'>
              <div className='pt-2'>
                {searchResult.length > 0 && (
                  <h2 className='' style={{ fontSize: '1.7rem' }}>
                    Encontrado(s) {searchResult.length} resultado(s) para sua busca
                  </h2>
                )}
                {searchResult.length < 1 && (
                  <h2 className='' style={{ fontSize: '1.7rem' }}>
                    Nenhum produto encontrado
                  </h2>
                )}
              </div>
            </div>
            {searchResult.length <= 0 && (
              <Empty description="Nenhum produto encontrado" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
            {searchResult.length > 0 && (
              <div className='card-body desktop-product-view' >
                <div className="row home-row justify-content-center w-100" style={{ rowGap: 32 }}>
                  {pagination.map((p, i) => {
                    if (p.status === 'active') {
                      return (
                        <div className="col-12 d-flex" key={i} style={{ marginBottom: 32, justifyContent: 'center', paddingLeft: 0, paddingRight: 0, overflow: 'visible' }}>
                          <div
                            className="marketplace-card animate-fade-in-up"
                            style={{
                              borderRadius: 16,
                              boxShadow: '0 2px 16px rgba(26,42,78,0.09)',
                              border: '1px solid #f0f0f0',
                              background: '#fff',
                              minHeight: 180,
                              width: '100%',
                              display: 'flex',
                              flexDirection: 'row',
                              transition: 'box-shadow 0.18s, transform 0.18s',
                              cursor: 'pointer',
                              position: 'relative',
                              overflow: 'visible',
                            }}
                            onMouseEnter={e => {
                              e.currentTarget.style.transform = 'translateY(-4px) scale(1.02)';
                              e.currentTarget.style.boxShadow = '0 8px 32px rgba(26,42,78,0.13)';
                            }}
                            onMouseLeave={e => {
                              e.currentTarget.style.transform = 'none';
                              e.currentTarget.style.boxShadow = '0 2px 16px rgba(26,42,78,0.09)';
                            }}
                          >
                            <Link to={`/product/${p._id}`} className="text-decoration-none" style={{ display: 'block', position: 'relative', minWidth: 160, maxWidth: 220, width: 220, flexShrink: 0 }}>
                              <img
                                src={p.images[0] ? `${API}${p.images[0]}` : '/default-image.jpg'}
                                alt={p.name}
                                style={{
                                  width: '100%',
                                  height: 160,
                                  objectFit: 'cover',
                                  borderTopLeftRadius: 16,
                                  borderBottomLeftRadius: 16,
                                  background: '#f8f9fb',
                                }}
                              />
                              <span style={{ position: 'absolute', top: 12, left: 12, background: '#fff', color: '#007bff', fontWeight: 600, borderRadius: 12, padding: '2px 10px', fontSize: 13, boxShadow: '0 2px 8px #f0f0f0', border: '1px solid #e9ecef' }}>
                                <i className="fas fa-images me-1"></i>{p.images.length}
                              </span>
                            </Link>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', minWidth: 0, padding: '18px 0 18px 0', gap: 10 }}>
                              <Link to={`/product/${p._id}`} className="text-decoration-none">
                                <div style={{ fontWeight: 700, fontSize: 20, color: '#1a2a4e', marginBottom: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', paddingLeft: 16 }}>{p.name}</div>
                              </Link>
                              <div style={{ color: '#10b981', fontWeight: 700, fontSize: 22, paddingLeft: 16 }}>R${parseInt(p.price).format()}</div>
                              <div style={{ fontSize: 15, color: '#6c757d', display: 'flex', alignItems: 'center', gap: 6, paddingLeft: 16 }}>
                                <i className="fas fa-map-marker-alt me-1" style={{ color: '#007bff' }}></i>
                                {p.location?.name || <span className="text-muted">Localização não informada</span>}
                              </div>
                              <div style={{ fontSize: 15, color: '#6c757d', display: 'flex', alignItems: 'center', gap: 6, paddingLeft: 16 }}>
                                <i className="fas fa-user me-1"></i>
                                {p.author && (p.author.email) ? p.author.email : <span className="text-muted">Email não informado</span>}
                              </div>
                              <div style={{ fontSize: 14, color: '#888', display: 'flex', alignItems: 'center', gap: 6, paddingLeft: 16 }}>
                                <i className="fas fa-clock me-1"></i>
                                {p.createdAt && new Date(p.createdAt).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })}
                              </div>
                              {/* Condição - só exibe se não for vazio ou 'Qualquer' */}
                              {p.condition && p.condition !== 'Qualquer' && (
                                <div style={{ fontSize: 15, color: '#6c757d', display: 'flex', alignItems: 'center', gap: 6, paddingLeft: 16 }}>
                                  <i className="fas fa-tag me-1"></i>
                                  {p.condition === 'New' ? 'Novo' : p.condition === 'Used' ? 'Usado' : p.condition}
                                </div>
                              )}
                            </div>
                            <div style={{ minWidth: 100, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'space-between', padding: '18px 18px 18px 0' }}>
                              <div style={{ color: '#007bff', fontWeight: 700, fontSize: 18, textAlign: 'right' }}>R${parseInt(p.price).format()}</div>
                              <div style={{ color: '#f59e42', fontWeight: 600, fontSize: 15, marginTop: 8, display: 'flex', alignItems: 'center', gap: 4 }}>
                                <i className="fas fa-star"></i> 5,0
                              </div>
                              <button style={{ background: 'none', border: 'none', outline: 'none', cursor: 'pointer', marginTop: 12 }}>
                                <i className="fas fa-star" style={{ color: '#ff4d4f', fontSize: 28 }}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
                <MUIPagination
                  count={Math.ceil(searchResult.length / countPerPage)}
                  page={current || 1}
                  onChange={loadSearchResults}
                  color="primary"
                  size="medium"
                  showFirstButton={Math.ceil(searchResult.length / countPerPage) > 5}
                  showLastButton={Math.ceil(searchResult.length / countPerPage) > 5}
                />
              </div>
            )}

            {searchResult.length > 0 && (
              <div className='card-body mobile-product'>
                <div className="row home-row justify-content-center w-100" style={{ rowGap: 24, margin: 0 }}>
                  {pagination.map((p, i) => {
                    if (p.status === 'active') {
                      return (
                        <div key={i} className="col-12 d-flex" style={{ marginBottom: 24, justifyContent: 'center' }}>
                          <div className="marketplace-card animate-fade-in-up" style={{ borderRadius: 16, boxShadow: '0 2px 16px rgba(26,42,78,0.09)', border: '1px solid #f0f0f0', background: '#fff', minHeight: 320, width: '98vw', maxWidth: 420, display: 'flex', flexDirection: 'column', position: 'relative' }}>
                            <Link to={`/product/${p._id}`} className="text-decoration-none" style={{ display: 'block', position: 'relative' }}>
                              <img src={p.images[0] ? `${API}${p.images[0]}` : '/default-image.jpg'} alt={p.name} style={{ width: '100%', height: 150, objectFit: 'cover', borderTopLeftRadius: 16, borderTopRightRadius: 16, background: '#f8f9fb' }} />
                              <span style={{ position: 'absolute', top: 10, left: 10, background: '#fff', color: '#007bff', fontWeight: 600, borderRadius: 12, padding: '2px 10px', fontSize: 13, boxShadow: '0 2px 8px #f0f0f0', border: '1px solid #e9ecef' }}>
                                <i className="fas fa-images me-1"></i>{p.images.length}
                              </span>
                            </Link>
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', padding: '14px 14px 8px 14px' }}>
                              <Link to={`/product/${p._id}`} className="text-decoration-none">
                                <div style={{ fontWeight: 700, fontSize: 16, color: '#1a2a4e', marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{p.name}</div>
                              </Link>
                              <div style={{ color: '#10b981', fontWeight: 700, fontSize: 18, marginBottom: 2 }}>R${parseInt(p.price).format()}</div>
                              <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <i className="fas fa-map-marker-alt me-1" style={{ color: '#007bff' }}></i>
                                {p.location?.name || <span className="text-muted">Localização não informada</span>}
                              </div>
                              <div style={{ fontSize: 12, color: '#888', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <i className="fas fa-clock me-1"></i>
                                {p.createdAt && new Date(p.createdAt).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short' })}
                              </div>
                              <div style={{ fontSize: 12, color: '#888', marginBottom: 0, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <i className="fas fa-user me-1"></i>
                                {p.author && (p.author.name || p.author.username) ? (p.author.name || p.author.username) : <span className="text-muted">Autor não informado</span>}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
                <MUIPagination
                  count={Math.ceil(searchResult.length / countPerPage)}
                  page={current || 1}
                  onChange={loadSearchResults}
                  color="primary"
                  size="medium"
                  showFirstButton={Math.ceil(searchResult.length / countPerPage) > 5}
                  showLastButton={Math.ceil(searchResult.length / countPerPage) > 5}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SearchResult;
